<div
  [class]="this.examService.isForm && !pdfToShow ? 't-popup popup-graphs form' : 't-popup popup-graphs'"
  style="display: block; height: 100%"
>
  <div class="popup-close"></div>
  <div class="popup-frame">
    <div class="popup-body">
      <ng-container
        *ngIf="
          !signatureService.isExamSigned(examService.examObject) &&
          examService.ExamType !== 'Consultation Letter'
        "
      >
        <h2>Report Preview</h2>
        <div
          *ngIf="
            !signatureService.isExamSigned(examService.examObject) &&
            signature &&
            isPreviewGenerated &&
            !isPDFLoading
          "
          style="padding: 0.5em"
        >
          <strong> Are you sure you want to sign this exam? This will lock the exam. </strong>
          <button (click)="handleSignAndPrint()" class="confirm--btn">Yes + Print</button>
          <button (click)="handleSign()" class="confirm--btn">Yes</button>
          <button (click)="closed.emit(null)" class="cancel--btn">Cancel</button>
        </div>
      </ng-container>
      <!-- <h2 *ngIf="!examservice.signed">Report Preview</h2> -->
      <!-- <div *ngIf="!examservice.signed && signature && !this.examservice.isForm" style="padding: 0.5em">
        Are you sure you want to sign this exam? This will lock the exam at midnight.
        <span (click)="closed.emit('sign')" style="margin-left: 2em; cursor: pointer">Yes</span>
        <span (click)="closed.emit(null)" style="margin-left: 2em; cursor: pointer">Cancel</span>
      </div> -->
      <div *ngIf="!examService.signed && signature && this.examService.isForm" style="padding: 0.5em">
        Are you sure you want to sign this form?
        <span (click)="closed.emit('sign')" style="margin-left: 2em; cursor: pointer">Yes</span>
        <span (click)="closed.emit(null)" style="margin-left: 2em; cursor: pointer">Cancel</span>
      </div>
      <div class="graphs-container">
        <div class="l-flex-c t-set" *ngIf="ShowOptions">
          <div class="t-set-title" *ngIf="!this.examService.isForm">
            <div class="l-flex-c">
              <label *ngIf="pdf.printImages">
                &nbsp;
                <select [(ngModel)]="pdf.perPage" class="t-select t-field menstural-field">
                  <option value="2">2</option>
                  <option value="6">6</option>
                </select>
                <span> Per Page </span>
              </label>
              <label>
                <input
                  type="checkbox"
                  name="gestation_TEMP_name_0"
                  class="custom-check -sq"
                  value="y"
                  [(ngModel)]="pdf.newTab"
                />
                <i class="customInput-display"></i>
                <span> Open in new tab </span>
              </label>
              <label *ngIf="login.letterhead">
                <input
                  type="checkbox"
                  name="gestation_TEMP_name_0"
                  class="custom-check -sq"
                  value="y"
                  [(ngModel)]="pdf.letterhead"
                />
                <i class="customInput-display"></i>
                <span> Use preprinted paper </span>
              </label>
            </div>
          </div>
          <div>
            <label *ngIf="this.examService.isForm">
              <input
                type="checkbox"
                name="gestation_TEMP_name_0"
                class="custom-check -sq"
                value="y"
                [(ngModel)]="pdf.newTab"
              />
              <i class="customInput-display"></i>
              <span> Open in new tab </span>
            </label>
            <label for="select_fetus" class="t-select-label" style="margin-left: 1em">Language</label>
            <select id="select_fetus" class="t-field t-select" [(ngModel)]="pdf.Lang">
              <option value="en-US">English</option>
              <option value="he-IL">עברית</option>
              <!--<option value='ar-JO'>عربى</option>
                                    <option value='it-IT'>Italiano</option>
                                    <option value='es-ES'>Español</option>-->
            </select>
          </div>
          <div>
            <label for="select_print_style" class="t-select-label" style="margin-left: 1em">Print Style</label>
            <select id="select_print_style" class="t-field t-select" [(ngModel)]="pdf.Style">
              <option value="simple">Plain</option>
              <option value="fancy">Decorated</option>
            </select>
          </div>
          <div  style="width:fit-content;margin-top: 1em;" *ngIf="!this.signatureService.isExamSigned(examService.examObject) && this.examService.ExamType !== 'Consultation Letter'">
            <span class="t-menu">Edit Exam Title to:
              <select class="t-select color" #Title [(ngModel)]="newTitle"
                (ngModelChange)="changeTitle = newTitle ? true : false"
                [disabled]="examService.isClosed">
                <option [ngValue]="null">Use Default Title</option>
                <option *ngFor="let c of examService.CustomTitles" [value]="c.Title">{{c.Title}}</option>
              </select>
              <span *ngIf="!examService.CustomTitles || examService.CustomTitles.length === 0" style="margin-left: 0.5em; font-size: 0.9em; color: #999;">
                (No custom titles defined)
              </span>
            </span>
          </div>
          <button
            class="search-btn"
            (click)="
              getPDF(!this.signatureService.isExamSigned(examService.examObject) ? 'preview' : '')
            "
            style="width: 4em; margin-left: 1em"
            *ngIf="showGo"
          >
            Go
          </button>
          <button
            class="search-btn"
            (click)="resendChameleon()"
            style="width: 12em; position: absolute; right: 0"
            *ngIf="chameleon"
          >
            Resend to Chameleon
          </button>
        </div>
        <button
          class="search-btn"
          (click)="resendChameleon()"
          style="width: 12em; margin-left: auto; margin-right: 2em; margin-top: -2.5em"
          *ngIf="login.hasChameleon && chameleon && !ShowOptions && examService.PregCopied"
        >
          Resend to {{ login.altArchiveName ? login.altArchiveName : "Chameleon" }}
        </button>
        <app-gallery
          *ngIf="pdf.printImages && showGallery && ShowOptions"
          style="width: 100%"
          [forprint]="true"
        >
        </app-gallery>
        <embed
          *ngIf="!isPDFLoading && pdfToShow != null"
          [src]="pdfToShow"
          type="application/pdf"
          style="width: 95vw; height: 80vh; z-index: 1"
        />
        <img
          *ngIf="isPDFLoading"
          src="../../assets/images/Wedges.svg"
          style="
            z-index: 0;
            margin-left: auto;
            margin-right: auto;
            position: absolute;
            left: 0;
            right: 0;
            top: 40vh;
          "
        />
      </div>
      <button type="button" class="popup-close-button" (click)="closed.emit()">Close printout</button>
    </div>
  </div>
</div>
